export default __webpack_public_path__ + "images/5L.28a7dbc.png";